import { jsx as c } from "react/jsx-runtime";
import { MultisynqRoot as u } from "@multisynq/react";
import { ReactTogetherContext as R } from "../context/ReactTogetherContext.js";
import _ from "../models/ReactTogetherModel.js";
import { getSessionNameFromUrl as N, getSessionPasswordFromUrl as x } from "../utils/urls.js";
import { deriveNickname as T } from "../utils/users.js";
const d = "__rt-userId";
function M({
  children: m,
  sessionParams: o,
  sessionIgnoresUrl: f,
  userId: e,
  deriveNickname: p = T,
  rememberUsers: r = !1
}) {
  const { appId: w, apiKey: g } = o;
  let n;
  f || (n = {
    sessionUrl: window.location.origin + window.location.pathname
  });
  const a = new URL(window.location.href), h = N(a), v = x(a), S = o.model || _, l = h || o.name, s = v || o.password;
  if (r && e === void 0) {
    let i = localStorage.getItem(d);
    i === null && (i = Math.random().toString(36).substring(2, 15), localStorage.setItem(d, i)), e = i;
  }
  let t = o.viewData;
  return e !== void 0 && (t === void 0 ? t = { userId: e } : t.userId = e), /* @__PURE__ */ c(
    u,
    {
      sessionParams: {
        model: S,
        name: l,
        password: s,
        appId: w,
        apiKey: g,
        options: n,
        viewData: t
      },
      deferSession: !l || !s,
      showChildrenWithoutSession: !0,
      children: /* @__PURE__ */ c(R.Provider, { value: { deriveNickname: p, rememberUsers: r }, children: m })
    }
  );
}
export {
  M as default
};
